import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-step-ua-resource-creation',
  templateUrl: './step-ua-resource-creation.component.html',
  styleUrls: ['./step-ua-resource-creation.component.css']
})
export class StepUaResourceCreationComponent {
  @Input() form!: FormGroup;
}
